export const PALETTE = {
  primary: "#2563EB",
  "primary-dark": "#1D4ED8",
  success: "#22C55E",
  warning: "#F59E0B",
  error: "#DC2626",
  bg: "#F8FAFC",
  text: "#0F172A",
  "text-secondary": "#334155",
  border: "#E2E8F0"
} as const;

export const BRAND = {
  name: "MiGestor",
  version: "v1.0.0",
  palette: PALETTE,

  logo: `
<svg class="h-10 w-10" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">

  <defs>
    <linearGradient id="hexGradient" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="#1D4ED8"/>
      <stop offset="100%" stop-color="#22C55E"/>
    </linearGradient>
  </defs>

  <polygon
      points="256,40 430,140 430,340 256,440 82,340 82,140"
      fill="none"
      stroke="url(#hexGradient)"
      stroke-width="34"
      stroke-linejoin="round"/>

  <rect x="175" y="255" width="42" height="95" rx="10" fill="#2563EB"/>
  <rect x="235" y="205" width="42" height="145" rx="10" fill="#1D4ED8"/>
  <rect x="295" y="145" width="42" height="205" rx="10" fill="#22C55E"/>

</svg>`,

  logoSmall: `
<svg class="h-8 w-8" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">

  <polygon
      points="16,3 24.5,8 24.5,17.5 16,22.5 7.5,17.5 7.5,8"
      fill="none"
      stroke="#2563EB"
      stroke-width="1.5"
      stroke-linejoin="round"/>

  <rect x="11" y="16" width="3" height="5" rx="0.8" fill="#2563EB"/>
  <rect x="14.5" y="13" width="3" height="8" rx="0.8" fill="#1D4ED8"/>
  <rect x="18" y="9.5" width="3" height="11.5" rx="0.8" fill="#22C55E"/>

</svg>`
};